import ButtonWithOauth from '@components/ButtonWithOAuth'
import useCurrentUser from '@hooks/useCurrentUser'

const Canva = () => {
  const currentUserPayload = useCurrentUser()

  return (
    <ButtonWithOauth
      authProviderKey="canva"
      buttonStyle="secondaryCreate"
      queryParams={{
        current_user_id: currentUserPayload.currentUser.id,
        redirect: window.location.href,
      }}
      size="medium"
      // @ts-expect-error
      width="auto"
    >
      Connect with Canva
    </ButtonWithOauth>
  )
}

export default Canva
